import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { DeviceCheckService } from "src/app/core/survey/shared/services/device-check.service";
import { SurveyStatus } from "../../Models/enums/SurveySurveyStatus";

@Component({
  selector: "app-survey-status-button",
  templateUrl: "./survey-status-button.component.html",
  styleUrls: ["./survey-status-button.component.scss"],
})
export class SurveyStatusButtonComponent {
  @Input() status: SurveyStatus;
  @Input() abbreviate: boolean = true;
  @Input() hasOngoingUpload: boolean = false;
  @Input() hasFailedUpload: boolean = false;

  surveyStatus = SurveyStatus;

  constructor(private deviceCheckService: DeviceCheckService) {}

  get statusString() {
    if (!this.abbreviate || !this.deviceCheckService.widthCheck(1100))
      return surveyStatusMapper[this.status];
    return abbreviateSurveyStatusMapper[this.status];
  }
}
const surveyStatusMapper = {
  [SurveyStatus.InsideDone]: "Inside Done",
  [SurveyStatus.InsideOnGoing]: "Inside Ongoing",
  [SurveyStatus.InsidePending]: "Inside Pending",
  [SurveyStatus.InsideWaitingForValidation]: "Inside Waiting For Validation",
  [SurveyStatus.OutsideDone]: "Outside Done",
  [SurveyStatus.OutsideOnGoing]: "Outside Ongoing",
  [SurveyStatus.OutsidePending]: "Outside Pending",
  [SurveyStatus.OutsideWaitingForValidation]: "Outside Waiting For Validation",
  [SurveyStatus.Prefill]: "Outside Prefilled",
};
const abbreviateSurveyStatusMapper = {
  [SurveyStatus.InsideDone]: "ID",
  [SurveyStatus.InsideOnGoing]: "IG",
  [SurveyStatus.InsidePending]: "IP",
  [SurveyStatus.InsideWaitingForValidation]: "IWV",
  [SurveyStatus.OutsideDone]: "OD",
  [SurveyStatus.OutsideOnGoing]: "OG",
  [SurveyStatus.OutsidePending]: "OP",
  [SurveyStatus.OutsideWaitingForValidation]: "OWV",
  [SurveyStatus.Prefill]: "PF",
};
